var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedArrowWidthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64112 6.85799C6.9991 7.21597 6.9991 7.79638 6.64112 8.15436L4.5393 10.2562H18.4466L16.3448 8.15436C15.9868 7.79638 15.9868 7.21597 16.3448 6.85799C16.7027 6.50001 17.2831 6.50001 17.6411 6.85799L21.3078 10.5247C21.6658 10.8826 21.6658 11.463 21.3078 11.821L17.6411 15.4877C17.2831 15.8457 16.7027 15.8457 16.3448 15.4877C15.9868 15.1297 15.9868 14.5493 16.3448 14.1913L18.4466 12.0895H4.5393L6.64112 14.1913C6.9991 14.5493 6.9991 15.1297 6.64112 15.4877C6.28314 15.8457 5.70274 15.8457 5.34476 15.4877L1.67809 11.821C1.32011 11.463 1.32011 10.8826 1.67809 10.5247L5.34476 6.85799C5.70274 6.50001 6.28314 6.50001 6.64112 6.85799Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedArrowWidthIcon);
export default __webpack_public_path__ + "static/media/DeprecatedArrowWidthIcon.55546961d6c09f234829713f90d36f74.svg";
export { ForwardRef as ReactComponent };